


































































































































































































































































































































































































































































































































































































































// @ts-nocheck
import cloneDeep from "lodash/cloneDeep";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import {
  getDefaultDealListDates,
  hasDealListDates,
} from "./queries/common/default_dates";

import TitleBar from "@/components/Elements/TitleBar.vue";
import DealDetails from "../DealDetails/DealDetails.vue";
import moment from "moment";
import XLSX from "xlsx";
import ClientComplaintsForm from "../ClientComplaintsForm/ClientComplaintsForm.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",
      "previewDealProducts",

      "documents",
      "lastMeta",
      "stats",
    ]),
    ...mapGetters(STORE_KEY, ["mixcartRejectCount"]),
  },
  // methods: {
  //   ...mapActions(STORE_KEY, ['copyDeal']),
  // },
  components: {
    TitleBar,
    DealDetails,
  },
})
export default class EmployeeList extends Vue {
  radioButton = 1;
  previewRow = null;

  open = false;
  prevent = false;

  get titleStack() {
    return ["Заявки"];
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null;
  }

  // ---------------------------------------------------------------------------

  get sourceTypes() {
    return [
      {
        id: "crm",
        label: "CRM",
      },
      {
        id: "lk",
        label: "Личный кабинет",
      },
      {
        id: "mixcart",
        label: "Микскарт",
      },
    ];
  }

  filterForm: any = {};
  dealsIds: any = [];

  get filtersCount() {
    return Object.keys(this.filterForm).reduce(
      (cur: number, filterKey: any) => {
        return (
          cur +
          (this.filterForm[filterKey] && this.filterForm[filterKey].length > 0
            ? 1
            : 0)
        );
      },
      0,
    );
  }

  @Watch("$route.query")
  public checkFilterChange() {
    const queryDate = this.getQueryParam("dates");
    let dates = null;

    if (Array.isArray(queryDate)) {
      dates = [
        // @ts-ignore
        moment(queryDate[0]).toDate(),
        // @ts-ignore
        moment(queryDate[1]).toDate(),
      ];
    }
    const queryCreateDate = this.getQueryParam("create_dates");
    let create_dates = null;

    if (Array.isArray(queryCreateDate)) {
      create_dates = [
        // @ts-ignore
        moment(queryCreateDate[0]).toDate(),
        // @ts-ignore
        moment(queryCreateDate[1]).toDate(),
      ];
    }

    this.filterForm = {
      statuses: this.getQueryParam("statuses"),
      clientId: this.getQueryParam("clientId"),
      cities: this.getQueryParam("cities"),
      warehouses: this.getQueryParam("warehouses"),
      destination_warehouses: this.getQueryParam("destination_warehouses"),
      deliveryZoneGroups: this.getQueryParam("deliveryZoneGroups"),
      dates,
      create_dates,
      wichSamples: this.getQueryParam("wichSamples"),
      onlyCorrections: this.getQueryParam("onlyCorrections"),
      onlyExportedTo1c: this.getQueryParam("onlyExportedTo1c"),
      clientTypes: this.getQueryParam("clientTypes"),
      dealsTypes: this.getQueryParam("dealsTypes"),
      source: this.getQueryParam("source"),
    };
  }

  applyFilter() {
    const filterForm = cloneDeep(this.filterForm);

    Object.keys(filterForm).map((item: any) => {
      if (!filterForm[item] || filterForm[item].length == 0) {
        delete filterForm[item];
      }
    });

    if (!filterForm.dates) {
      filterForm.dates = getDefaultDealListDates();
    }

    if (Array.isArray(filterForm.dates)) {
      filterForm.dates = [
        moment(filterForm.dates[0]).format("YYYY-MM-DD"),
        moment(filterForm.dates[1]).format("YYYY-MM-DD"),
      ];
    } else {
      delete filterForm.dates;
    }
    if (Array.isArray(filterForm.create_dates)) {
      filterForm.create_dates = [
        moment(filterForm.create_dates[0]).format("YYYY-MM-DD"),
        moment(filterForm.create_dates[1]).format("YYYY-MM-DD"),
      ];
    } else {
      delete filterForm.create_dates;
    }
    if (this.$route.query.name) {
      filterForm["name"] = this.$route.query.name;
    }

    this.$router.replace({
      query: {
        ...filterForm,
      },
    });

    (this.$refs.filter as any).close();
  }

  clearFilter() {
    this.filterForm = {
      statuses: null,
      cities: null,
      warehouses: null,
      destination_warehouses: null,
      deliveryZoneGroups: null,
      dates: null,
      create_dates: null,
      wichSamples: null,
      onlyCorrections: null,
      onlyExportedTo1c: null,
      clientTypes: null,
    };

    (this.$refs.filter as any).close();
  }

  addComplains() {
    console.log(this.dealsIds);

    this.$buefy.modal.open({
      component: ClientComplaintsForm,
      props: {
        isNew: true,
        documentPreview: {},
        initParams: {
          dealIds: this.dealsIds.map((row: any) => row.id),
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this,
    });
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [
      this.$route.query.sortField || "created_at",
      this.$route.query.sortDirection || "desc",
    ];
  }

  get selectedView() {
    return this.$route.query.view || "data";
  }

  get selectedDealsView() {
    return this.$route.query.deals_view || "deals";
  }

  setFilter(filterName: string, filterValue: any) {
    const query = this.$route.query;
    console.log("test => ", filterValue);
    if (!filterValue) {
      delete query[filterName];
    }
    this.$router.replace({
      query: {
        ...query,
        [filterName]: filterValue,
      },
    });
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction,
      },
    });
  }

  private delayFilter: any = null;
  private lastFilter: any = {};

  onSearch(filter: any) {
    this.lastFilter = filter;
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...this.lastFilter,
          },
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.$router.replace({
      query: { ...this.$route.query, page },
    });
  }

  toDeal() {
    const routeData = this.$router.resolve({
      name: "deal-details",
      params: {
        // @ts-ignore
        id: this.previewRow.id,
      },
    });
    window.open(routeData.href, "_blank");
  }

  showPreview(row: any) {
    if (!this.prevent) {
      console.log("1", row);
      // @ts-ignore
      this.previewRow =
        !this.previewRow || this.previewRow.id != row.id ? row : null;
    }
  }

  handleOpenDeal() {
    this.prevent = true;
    console.log("2");
  }

  // ---------------------------------------------------------------------------

  copyDeal(deal: any) {
    this.$buefy.snackbar.open(`Начало копирования данных.`);

    this.$store
      .dispatch(`${STORE_KEY}/copyDeal`, deal)
      .then(() => {
        this.$buefy.snackbar.open(`Копирование завершено.`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open(
          `При копировании произошла ошибка. Попробуйте позже.`,
        );
      });
  }

  exportAsXLSX() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    const query = {
      ...this.$route.query,
      ...(this.dealsIds.length
        ? { dealId: this.dealsIds.map((row: any) => row.id) }
        : {}),
    };
    this.$store
      .dispatch(`${STORE_KEY}/exportDataAsXLSX`, query)
      .then(() => {
        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  exportAsXLSXForSoh() {
    this.$buefy.snackbar.open(
      `Начало выгрузки для СОХ. Данная процедура может занять некоторое время.`,
    );

    const query = {
      ...this.$route.query,
      ...(this.dealsIds.length
        ? { dealId: this.dealsIds.map((row: any) => row.id) }
        : {}),
    };
    this.$store
      .dispatch(`${STORE_KEY}/exportDataAsXLSXForSoh`, query)
      .then(() => {
        this.$buefy.snackbar.open(
          `Выгрузка для СОХ завершена. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При выгрузке для СОХ произошла ошибка.`);
      });
  }

  exportManufacturePlan() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    this.$store
      .dispatch(`${STORE_KEY}/exportDataForManufacturePlan`, {
        ...this.$route.query,
      })
      .then(() => {
        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  exportNoname1() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    this.$store
      .dispatch(`${STORE_KEY}/exportDataForNoname1Export`, {
        ...this.$route.query,
      })
      .then(() => {
        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  exportNoname2() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    this.$store
      .dispatch(`${STORE_KEY}/exportDataForNoname2Export`, {
        ...this.$route.query,
      })
      .then(() => {
        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  export1C() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    this.$store
      .dispatch(`${STORE_KEY}/export1C`, {
        ...this.$route.query,
      })
      .then((content: any) => {
        console.log(content);

        const sJson = JSON.stringify(content);
        const element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/json;charset=UTF-8," + encodeURIComponent(sJson),
        );
        element.setAttribute("download", "export.json");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click(); // simulate click
        document.body.removeChild(element);

        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  markSelectedAsExportedTo1c() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );

    const dealIds =
      this.dealsIds.length > 0 ? this.dealsIds.map((row: any) => row.id) : [];

    this.$store
      .dispatch(`${STORE_KEY}/export1C`, {
        ...this.$route.query,
        dealIds,
      })
      .then((content: any) => {
        console.log(content);

        const sJson = JSON.stringify(content);
        const element = document.createElement("a");
        element.setAttribute(
          "href",
          "data:text/json;charset=UTF-8," + encodeURIComponent(sJson),
        );
        element.setAttribute("download", "export.json");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );

        // После скачивания JSON устанавливаем флаг «Выгружено в 1С» для отмеченных заявок
        if (this.dealsIds.length > 0) {
          this.$store
            .dispatch(`${STORE_KEY}/setExportedTo1c`, this.dealsIds)
            .then(() => {
              this.$buefy.snackbar.open(
                `Флаг "Выгружено в 1С" установлен для ${this.dealsIds.length} заявок.`,
              );
              this.dealsIds = [];
              this.handleParamsChange();
            })
            .catch(() => {
              this.$buefy.snackbar.open(
                `При установке флага произошла ошибка. Попробуйте позже.`,
              );
            });
        }
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  exportList() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`,
    );
    const cols_props_10: any = { wch: 10, hpt: 15 };
    const cols_props_25: any = { wch: 25, hpt: 15 };

    this.$store
      .dispatch(`${STORE_KEY}/exportDataForListExport`, {
        ...this.$route.query,
      })
      .then((data) => {
        const csvContent: any[] = [];
        csvContent.push([
          "Дата доставки",
          "Наименование",
          "Воронка",
          "Этап",
          "Менеджер",
          "Адрес доставки",
          "Вес",
          "Стоимость",
        ]);
        data.documents.map((item: any) => {
          const row: any[] = [];
          row.push(item.expected_delivery_date);
          row.push(item.name);
          row.push(item.pipeline_name);
          row.push(item.status_name);
          row.push(item.manager_name);
          row.push(item.point_address);
          row.push(item.weight);
          row.push(item.price);
          csvContent.push(row);
        });

        const ws = XLSX.utils.aoa_to_sheet(csvContent);
        ws["!cols"] = [
          cols_props_10,
          cols_props_25,
          cols_props_25,
          cols_props_25,
          cols_props_25,
          cols_props_25,
          cols_props_10,
          cols_props_10,
        ];
        // @ts-ignore
        const range = XLSX.utils.decode_range(ws["!ref"]);
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellref = XLSX.utils.encode_cell({ c: C, r: R }); // construct A1 reference for cell
            if (!ws[cellref] || C < 6 || R < 1) continue; // if cell doesn't exist, move on
            const cell = ws[cellref];
            cell.t = "n";
            cell.z = "0.00";
          }
        }
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Заявки");
        XLSX.writeFile(wb, "export.xlsx");
        this.$buefy.snackbar.open(
          `Экспорт окончен. Файл должен был скачаться на ваш ПК.`,
        );
      })
      .catch(() => {
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  openDocument(row: any) {
    this.$router.push({
      name: "deal-details",
      params: {
        id: row.id,
      },
    });
  }

  toggleDealSelection(dealId: any) {
    if (this.dealsIds.indexOf(dealId) > -1) {
      this.dealsIds.pop(dealId);
    } else {
      this.dealsIds.push(dealId);
    }
  }

  setPayed() {
    this.$store.dispatch(`${STORE_KEY}/setStatus`, this.dealsIds);
  }

  moveDate() {
    this.$buefy.dialog.prompt({
      message: `Перенос заявок на дату`,
      inputAttrs: {
        type: "date",
        placeholder: "Новая дата доставки",
        value: moment().format("YYYY-MM-DD"),
      },
      confirmText: "Перенести",
      cancelText: "Отмена",
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/setDate`, {
          dealsIds: this.dealsIds,
          newDate: value,
        });
      },
    });
  }

  setExportedTo1c() {
    this.$buefy.dialog.confirm({
      message: `Установить флаг "Выгружено в 1С" для выбранных заявок (${this.dealsIds.length} шт.)?`,
      confirmText: "Установить",
      cancelText: "Отмена",
      type: "is-success",
      onConfirm: () => {
        this.$store
          .dispatch(`${STORE_KEY}/setExportedTo1c`, this.dealsIds)
          .then(() => {
            this.$buefy.snackbar.open(`Флаг "Выгружено в 1С" установлен.`);
            this.dealsIds = [];
            this.handleParamsChange();
          })
          .catch(() => {
            this.$buefy.snackbar.open(
              `При установке флага произошла ошибка. Попробуйте позже.`,
            );
          });
      },
    });
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.checkFilterChange();
    this.handleParamsChange();
  }

  // beforeDestroy() {
  //   this.$store.unregisterModule(STORE_KEY);
  // }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    if (!hasDealListDates(this.$route.query)) {
      const [dateFrom, dateTo] = getDefaultDealListDates();
      this.$router.replace({
        query: {
          ...this.$route.query,
          dates: [dateFrom, dateTo],
        },
      });
      return;
    }

    this.previewRow = null;
    this.prevent = false;
    if (this.$route.query.view == "stats") {
      this.$store.dispatch(`${STORE_KEY}/loadStatistic`, {
        ...this.$route.query,
      });
    } else {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...{
          sortField: this.$route.query.sortField || "created_at",
          sortDirection: this.$route.query.sortDirection || "desc",
        },
        ...this.$route.query,
      });
    }
  }
}
